// The positions of the records a progressive list already shows.
//
// A news page loads its next page by offset (`doc/pagination.md` 3: the
// "Показать ещё" button is an ordinary link to `?page=N`). An offset is
// counted at the moment of the request, so a post published between two
// presses moves every older post one place down, and the first card of the
// next page is the last card already on screen. The order is still the feed's
// order; the second copy is the only defect, and it is removed here.
//
// Pure, so the rule has a vitest spec without a DOM: the controller collects
// the `data-record-id` of every card in document order and removes the
// elements at the indexes this returns.
export function repeatedIndexes(ids: readonly string[]): number[] {
  const seen = new Set<string>()
  const repeated: number[] = []

  ids.forEach((id, index) => {
    if (seen.has(id)) {
      repeated.push(index)
    } else {
      seen.add(id)
    }
  })

  return repeated
}
